import React, { useEffect } from 'react';
import EditorJS from '@editorjs/editorjs';
import styled from 'styled-components';
const List = require('@editorjs/nested-list');
const Header = require('@editorjs/header');
const Underline = require('@editorjs/underline');
const EDITOR_JS_VERSION = '2.24.3';
export const CommentContainer = styled.div `
  max-width: 1280px;
`;
export const CommentTitle = styled.div `
  padding: 5px;

  span {
    padding-left: 20px;
    font-size: 20px;
    font-weight: var(--bold);
  }
`;
const DivEditor = styled('div') `
  border: 1px solid var(--main-grey-2-lighter);
  border-radius: 3px;
  width: 100%;
  padding: 10px;
  background-color: white;

  .codex-editor__redactor {
    padding-bottom: 100px !important;
  }

  .ce-block__content {
    max-width: 100% !important;
    margin-right: 50px;
  }

  .ce-toolbar {
    left: 100% !important;
  }
`;
export const makeEmptyOutputData = () => ({
    time: Date.now(),
    version: EDITOR_JS_VERSION,
    blocks: [
        {
            type: 'paragraph',
            data: {
                text: '',
            },
        },
    ],
});
export const makeOutputData = (source) => isValidOutputData(source) ? source : makeEmptyOutputData();
const isValidOutputData = (v) => {
    return v ? v.hasOwnProperty('blocks') : false;
};
export const areSameOutputData = (a, b) => JSON.stringify(a.toJS()) === JSON.stringify(b.toJS());
export const Editor = ({ onChange, id, placeHolder, initialValue, style }) => {
    useEffect(() => {
        const editorjs = new EditorJS({
            holder: id,
            placeholder: placeHolder,
            defaultBlock: 'paragraph',
            inlineToolbar: true,
            data: initialValue,
            onChange(api, event) {
                saved(api);
            },
            tools: {
                header: {
                    class: Header,
                    inlineToolbar: true,
                },
                list: {
                    class: List,
                    inlineToolbar: true,
                },
                underline: Underline,
                paragraph: {
                    inlineToolbar: true,
                },
            },
            i18n: {
                messages: {
                    /**
                     * Other below: translation of different UI components of the editor.js core
                     */
                    ui: {
                        blockTunes: {
                            toggler: {
                                'Click to tune': 'Cliquer pour régler',
                                'or drag to move': 'ou faites glisser pour déplacer',
                            },
                        },
                        inlineToolbar: {
                            converter: {
                                'Convert to': 'Convertir en',
                            },
                        },
                        toolbar: {
                            toolbox: {
                                Add: 'Ajouter',
                                Filter: 'Filtre',
                            },
                        },
                    },
                    /**
                     * Section for translation Tool Names: both block and inline tools
                     */
                    toolNames: {
                        Header: 'Titre',
                        Text: 'Paragraphe',
                        Heading: 'Titre',
                        List: 'Liste',
                        Warning: 'Attention',
                        Checklist: 'Checklist',
                        Quote: 'Citation',
                        Code: 'Code',
                        Delimiter: 'Délimiter',
                        'Raw HTML': 'Ligne HTML',
                        Table: 'Tableau',
                        Link: 'Lien',
                        Bold: 'Gras',
                        Italic: 'Italique',
                        InlineCode: 'Code en ligne',
                        Underline: 'Souligner',
                    },
                    /**
                     * Section for passing translations to the external tools classes
                     */
                    tools: {
                        /**
                         * Each subsection is the i18n dictionary that will be passed to the corresponded plugin
                         * The name of a plugin should be equal the name you specify in the 'tool' section for that plugin
                         */
                        warning: {
                            // <-- 'Warning' tool will accept this dictionary section
                            Title: 'Titre',
                            Message: 'Message',
                        },
                        table: {
                            'Add row above': 'Ajouter une ligne avant',
                            'Add row below': 'Ajouter une ligne après',
                            'Delete row': 'Supprimer une ligne',
                            'With headings': 'Avec titre',
                            'Without headings': 'Sans titre',
                            Heading: 'Titre',
                        },
                        /**
                         * Link is the internal Inline Tool
                         */
                        link: {
                            'Add a link': 'Ajouter un lien',
                        },
                        /**
                         * The "stub" is an internal block tool, used to fit blocks that does not have the corresponded plugin
                         */
                        stub: {
                            'The block can not be displayed correctly.': 'Le bloc ne peut pas être affiché correctement.',
                        },
                    },
                    /**
                     * Section allows to translate Block Tunes
                     */
                    blockTunes: {
                        /**
                         * Each subsection is the i18n dictionary that will be passed to the corresponded Block Tune plugin
                         * The name of a plugin should be equal the name you specify in the 'tunes' section for that plugin
                         *
                         * Also, there are few internal block tunes: "delete", "moveUp" and "moveDown"
                         */
                        delete: {
                            Delete: 'Effacer',
                        },
                        moveUp: {
                            'Move up': 'Déplacer au dessus',
                        },
                        moveDown: {
                            'Move down': 'Déplacer en dessous',
                        },
                    },
                },
            },
        });
        function saved(api) {
            setTimeout(() => {
                api.saver.save().then((outputdata) => {
                    onChange(outputdata);
                });
            }, 200);
        }
    }, []);
    return (React.createElement(DivEditor, { id: id, style: style }));
};
//# sourceMappingURL=Editor.js.map